const thwiftyCat_a = [
  {
    link: "Electronics",
    name: "Electronics",
    image: "https://cdn.ebtida.com/1772919847075-Electronics.jpg",
  },
  {
    link: "Fashion",
    name: "Fashion",
    image: "https://cdn.ebtida.com/1772919847075-Fashion.jpg",
  },
  {
    link: "Home",
    name: "Home",
    image: "https://cdn.ebtida.com/1772919847075-Home.jpg",
  },
  {
    link: "beauty",
    name: "beauty",
    image: "https://cdn.ebtida.com/1772919847075-Beauty.jpg",
  },
];

const thwiftyCM = [
  {
    link: "/store/deals",
    image: "https://cdn.ebtida.com/1772919847075-Mobile_00000.jpg",
  },
  {
    link: "/search/refurbished",
    image: "https://cdn.ebtida.com/1772919847075-Mobile2_00018.jpg",
  },
];

const thwiftyCat_b = [
  {
    link: "Sports",
    name: "Sports",
    image: "https://cdn.ebtida.com/1772919847075-Sports.jpg",
  },
  {
    link: "Accessories",
    name: "Accessories",
    image: "https://cdn.ebtida.com/1772919847075-Accessories.jpg",
  },
  {
    link: "gadgets",
    name: "gadgets",
    image: "https://cdn.ebtida.com/1772919847075-Gadgets.jpg",
  },
  {
    link: "Headphones",
    name: "Headphones",
    image: "https://cdn.ebtida.com/1772919847075-Headphones.jpg",
  },
];

const thwiftyCat_c = [
  {
    link: "watches",
    name: "watches",
    image: "https://cdn.ebtida.com/1704374368517-watches-1.png",
  },
  {
    link: "speakers",
    name: "speakers",
    image: "https://cdn.ebtida.com/1704482914220-Speakers-2.png",
  },
  {
    link: "music instruments",
    name: "music_instruments",
    image: "https://cdn.ebtida.com/1704374368517-Music-Instruments.png",
  },
  {
    link: "toys",
    name: "toys",
    image: "https://cdn.ebtida.com/1750465966744-Toys2-thwifty.jpg",
  },
  {
    link: "gaming console",
    name: "gaming_console",
    image: "https://cdn.ebtida.com/1704374368517-Gaming-Consoles-01.png",
  },
];

const thwiftyFashion = [
  {
    link: "Jeans",
    name: "Jeans",
    image: "https://cdn.ebtida.com/1772919847075-Jeans.jpg",
  },
  {
    link: "Shirts",
    name: "Shirts",
    image: "https://cdn.ebtida.com/1772919847075-Shirts.jpg",
  },
  {
    link: "Shoes",
    name: "Shoes",
    image: "https://cdn.ebtida.com/1772919847075-Shoes.jpg",
  },
  {
    link: "Jackets",
    name: "Jackets",
    image: "https://cdn.ebtida.com/1772919847075-Jackets.jpg",
  },
];

const category_a = thwiftyCat_a;
const category_b = thwiftyCat_b;
const category_c = thwiftyCat_c;
const fashion = thwiftyFashion;
const carousel = thwiftyCM;

const HomeData = {
  category_a: category_a,
  category_b: category_b,
  category_c: category_c,
  fashion: fashion,
  carousel: carousel,
};

export default HomeData;
